import { createContext } from 'react';

/**
 * Context used by the useListingSupport hook.
 */
export const ListingSupportContext = createContext();
